import { FC } from 'react';

import { HStack } from '@ui-furniture/elements';
import { AddressTypeahead } from '@ui-furniture/ui/inputs/address-typeahead';

export const AddressChatInput: FC<{
  onAnswer: (answer: { text: string; id: string }) => void;
}> = ({ onAnswer }) => {
  return (
    <HStack>
      <AddressTypeahead menuPlacement='top' onSelect={onAnswer} />
    </HStack>
  );
};
